import {Component, OnDestroy, OnInit} from '@angular/core';
import {Filters, Formatters, GridOption} from 'angular-slickgrid';
import {Subscription} from 'rxjs';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';

@Component({
  selector: 'app-roles-lt',
  templateUrl: './roles-lt.component.html',
  styleUrls: ['./roles-lt.component.css']
})
export class RolesLTComponent implements OnInit, OnDestroy {

  displayed = true;
  selected: number;
  gridOptions: GridOption;
  roles: any[];

  show: boolean;
  rolename: string;
  roledesc: string;
  dataset: any[];
  totalData = 0;
  selectedTitles: any[];
  slideChecked = false;

  private respObject: any;
  displayData: any;

  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;
  nextOffset: number;
  previousOffset: number;
  collectionSize: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private adminAuth: Subscription;

  private notifier: NotifierService;
  private clientId: number;
  private baseFlag: any;
  private type: string;
  offset: number;

  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (this.baseFlag) {
            if (!this.edit) {
              this.notifier.notify('error', 'You do not have edit permission');
            } else {
              if (confirm('Are you sure?')) {
                // console.log('item---' + JSON.stringify(item));
                this.editItem(item);
              }
            }
          } else {
            if (!this.messageService.edit) {
              this.notifier.notify('error', 'You do not have edit permission');
            } else {
              if (confirm('Are you sure?')) {
                // console.log('item---' + JSON.stringify(item));
                this.editItem(item);
              }
            }
          }
          break;
        case 'delete':
          if (this.baseFlag) {
            if (!this.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              if (confirm('Are you sure?')) {
                this.deleteItem(item);
              }
            }
          } else {
            if (!this.messageService.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              if (confirm('Are you sure?')) {
                this.deleteItem(item);
              }
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });

  }

  deleteItem(item) {
    this._rest.deleteUserRoleDB({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.messageService.sendAfterDelete(item.id);
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.respObject.errorMessage);
    });
  }

  editItem(item) {
    const data = {
      name: item.name, desc: item.roleDesc, createdBy: this.messageService.getUserId(), superAdmin: item.superAdmin, id: item.id
    };
    // console.log('data---' + JSON.stringify(data));
    this._rest.editRoleMst(data).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.notifier.notify('success', 'Updated Successfully');
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.respObject.errorMessage);
    });
  }

  ngOnInit() {
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.paginationType = 'next';
    this.page_no = 0;
    this.totalPage = 0;
    this.type = 'emp';
    this.displayData = {
      pageName: 'Maintain Role ',
      openModalButton: 'Add Role',
      breadcrumb: 'Roles',
      folderName: 'All Role',
      tabName: 'Roles'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Role Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'rolename', name: 'Role Name', field: 'name', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'roledesc', name: 'Role Description', field: 'roleDesc', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'type', name: 'Role Type', field: 'type', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }
  }

  onPageLoad() {
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  openModal(content) {
    if (this.baseFlag) {
      if (!this.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.rolename = '';
        this.roledesc = '';
        this.modalService.open(content, {size: 'sm'}).result.then((result) => {
        }, (reason) => {

        });
      }
    } else {
      if (!this.messageService.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.rolename = '';
        this.roledesc = '';
        this.modalService.open(content, {size: 'sm'}).result.then((result) => {
        }, (reason) => {

        });
      }
    }
  }

  save() {
    const data = {
      client_id: this.clientId,
      name: this.rolename,
      desc: this.roledesc,
      superadmin: this.slideChecked,
      type: this.type,
      createdBy: this.messageService.getUserId()
    };
    console.log(JSON.stringify(data));
    if (!this.messageService.isBlankField(data)) {
      this._rest.addRole(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          const id = this.respObject.roleId;
          this.messageService.setRow({name: this.rolename, roleDesc: this.roledesc, id: id, type: this.type});
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.rolename = '';
          this.roledesc = '';
          this.slideChecked = false;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (this.baseFlag) {
      if (!this.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
      }
    } else {
      if (!this.messageService.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
      }
    }
  }

  getNewTableData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this._rest.getSomeRoleClientWise(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('err', this.messageService.SERVER_ERROR);
    });
  }

  slideChange() {
    this.slideChecked = !this.slideChecked;
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  // getData(paginationObj) {
  //   const offset = paginationObj.offset;
  //   const paginationType = paginationObj.paginationType;
  //   this._rest.getSomeModules(offset, this.pageSize, paginationType).subscribe((res) => {
  //     this.respObject = res;
  //     this.executeResponse(this.respObject, offset, paginationType);
  //   }, (err) => {
  //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
  //   });
  // }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }

  onButtonChange(button) {
    this.type = button.value;
    console.log(this.type);
  }
}
